module.exports = __webpack_public_path__ + "static/media/clinical_data_csv_icon.fe76547e.svg";